<template>
    <div class="consul-deal clearfix" >
    <div class="consul-sheet-wrap clearfix" v-loading="!isSuccess" style="width:100%;">
        <div class=" marginP " >
            <div v-if="isSuccess" class="consul-part1 part" >
            <ImageAmplify/>
            <div class="video-Top">
                <label class="searchTip">远程会诊申请信息</label>
            </div>
            <div class="clearfix" style="box-sizing: border-box;padding:0px 20px 0px 20px">
                <div class="sheet-content number-wrap clearfix">
                    <label class="fl order-num jet-black">NO.{{ consultDetail.consultGroup.consultGroupNo }}</label>
                    <label class="fr order-num jet-black">问诊费用：<span class="fee-num">￥{{ consultDetail.consultGroup.consultFee }}</span></label>
                </div>
                <div class="clearfix h30  marginT5">
                    <span class="name patient-list-item jet-black lineH30 fontSize14">{{ consultDetail.consultGroup.consulterName }}</span>
                    <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consultGroup.consulterGender =="M"?"男":"女" }}</span>
                    <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consultGroup.consulterAge }}岁</span>
                    <span class="patient-list-item lineH30 jet-gray">电话：{{ consultDetail.consultGroup.consulterMobile }}</span>
                    <span class="patient-list-item lineH30 jet-gray">身份证：{{ consultDetail.consultGroup.consulterIdcard }}</span>
                    <span class="patient-list-item lineH30 jet-gray">职业：{{ consultDetail.consultGroup.consulterJob?consultDetail.consultGroup.consulterJob:'无' }}</span>
                    <span class="patient-list-item lineH30 jet-gray">患者住院号：{{ consultDetail.consultGroup?consultDetail.consultGroup.consulterInhosno:'无'}}</span>
                </div>
                <div class="patient-form sheet-content">
                    <div class=" marginB10 paddingT10">
                        <span class="jet-gray">邀请会诊医生：</span>{{inviteDoc}}
                        <span class="jet-gray marginL20">邀请会诊时间：</span>{{consultDetail.consultGroup.hopeTime}}
                    </div>
                    <div class="lineH22 marginB10">
                        <span class="jet-gray">申请类型：</span>{{ consultDetail.consultGroup.consultGroupType }}
                        <span class="jet-gray marginL20">辅助诊断类型：</span>{{ consultDetail.consultGroup.auxiliaryDiagnose }}
                    </div>
                    <div class="bgc-white">
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">患者主诉：</span>{{ consultDetail.consultGroup.consultContent }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">初步诊断：</span>{{ consultDetail.consultGroup.beforeDiagnose }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">会诊目的：</span>{{ consultDetail.consultGroup.consultReason }}
                        </div>
                    </div>
                    <div class="add-pic-list">
                        <img v-for="(item,index) in imgList" class="item-pic w88 h88" :src="item.url" :key="index" @click="handleImageAmplify(index, imgList, $event)">
                    </div>
                    <ul class="el-upload-list el-upload-list--text">
                        <li class="el-upload-list__item is-success" v-for="(item, index) in fileList" :key="index">
                            <a class="el-upload-list__item-name" :href="item.url" target="_blank">
                                <i class="el-icon-document"></i>
                                {{ item.attaFileName }}
                            </a>
                        </li>
                    </ul>
                    <!--<div class="lineH22">
                        <span class="jet-gray">病情附件：</span>{{ '无' }}
                    </div>-->
                    <div class="consul-form-item h30 bgc-white">
                        <div class="fr">
                            <label class="light-gray">申请时间：</label>
                            <span class="label-content light-gray">{{ formatUnix(consultDetail.consultGroup.createTime) }}</span>
                            <label class="light-gray">申请医生：</label>
                            <span class="light-gray">{{ consultDetail.consultGroup.initHosName+' - '+consultDetail.consultGroup.initDeptName+' - '+consultDetail.consultGroup.initDocName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="video-Top">
                <label class="searchTip">安排信息</label>
            </div>
                <div style="box-sizing: border-box;padding:0px 20px;">
                    <div class="opinionPart sheet-content evaluate-launch-wrap marginT10 clearfix">
                        <div class="lineH22 marginB10 fl">
                            <span class="jet-gray">取消理由：</span><span class="fee-num">{{ consultDetail.consultGroup.disagreeReason?consultDetail.consultGroup.disagreeReason:'无' }}</span>
                        </div>
                    </div>
                    <div class="consul-form-item h30 bgc-white sheet-content">
                        <div class="fr">
                            <label class="light-gray">处理时间：</label>
                            <span class="label-content light-gray">{{ formatUnix(consultDetail.consultGroup.modifyTime) }}</span>
                            <label class="light-gray">处理人：</label>
                            <span class="light-gray">{{ consultDetail.consultGroup.modifierName }}</span>
                        </div>
                    </div>
                </div>
        </div>
        </div>
    </div>
    </div>
</template>
<style>

</style>
<script>
    import { Loading, Message } from "element-ui";
    import fileClassification from "../../utils/FileClassificationUtils";
    import basicParam from "../../data/basicParam.js";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import ImageAmplify from "../common/ImageAmplify.vue";
    import { imageAmplify } from "../../utils/AmplifyImage.js";
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import Vue from "vue";
    Vue.use(Loading);
    export default{
        data: function(){
            return {
                consultDetail: null,//会诊单详细信息
                isSuccess: false,//表单详情是否加载成功

                imgList: [],//附件图片列表
                fileList: [],//附件文件列表
            }
        },
        components: {
           ImageAmplify
        },
        created: function(){//获取会诊单数据
            this.getConsultDetail();
        },
        computed: {
            consultId: function(){//获取会诊单编号
                return this.$route.params.consultId;//获取会诊单编号
            },
            inviteDoc: function () {//邀请医生
                if(this.consultDetail.consultGroup.hopeDeptId){//医-助-医会诊
                    if(this.consultDetail.consultGroup.hopeDocName){//可能没有期望医生
                        return this.consultDetail.consultGroup.hopeHosName + ' - ' + this.consultDetail.consultGroup.hopeDeptName + ' - ' + this.consultDetail.consultGroup.hopeDocName
                    }else {
                        return this.consultDetail.consultGroup.hopeHosName + ' - ' + this.consultDetail.consultGroup.hopeDeptName;
                    }
                }else {
                    return this.consultDetail.consultGroup.acceptHosName + ' - ' + this.consultDetail.consultGroup.acceptDeptName + ' - ' + this.consultDetail.consultGroup.acceptDocName
                }
            },
        },
        methods: {
            formatUnix: function(time){//将unix时间戳转换未yyyy-MM-dd HH:mm
        	     return formatUnixTime(time);
        	},
            getConsultDetail: function(){//根据consultId获取会诊单数据
                this.isSuccess = false;
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.detail"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.consultDetail = data.obj;
                    //获取附件并分组图片和文件
                    fileClassification(data.obj.attaList, _this.imgList, _this.fileList);
                }, function () {
                    _this.isSuccess = true;
                });
            },
        }
    }
</script>
